<template>
  <div class="container">
    <div class="row">
      <!-- Panel izquierdo para seleccionar el archivo y mostrar el PDF generado (70%) -->
      <div class="col-left">
        <div class="file-selection">
          <button @click="showPdf(1)" class="file-btn">Ver Indicaciones</button>
          <button @click="showPdf(2)" class="file-btn">Ver Certificado Médico</button>
        </div>
        <iframe :src="pdfUrl" v-if="pdfUrl" frameborder="0" class="pdf-viewer"></iframe>
        <div v-else class="no-pdf">Selecciona un archivo para visualizarlo aquí</div>
      </div>

      <!-- Panel derecho para el formulario de firma (30%) -->
      <div class="col-right">
        <div class="form-container card">
          <div class="form-header">
            <h3>Firma Electrónica</h3>
            <p>Complete los siguientes campos para firmar los PDFs</p>
          </div>
          <div class="input-group">
            <label for="keystore">Archivo Keystore:</label>
            <input id="keystore" type="file" @change="onKeystoreChange" placeholder="Archivo Keystore"/>
            <small v-if="keystoreName">{{ keystoreName }}</small>
          </div>
          <div class="input-group">
            <label for="password">Contraseña del Keystore:</label>
            <input id="password" v-model="password" type="password" placeholder="Contraseña del Keystore" />
          </div>
          <div class="input-group">
            <label for="reason">Motivo:</label>
            <input id="reason" v-model="reason" type="text" placeholder="Motivo de la firma" disabled/>
          </div>
          <div class="input-group">
            <label for="location">Ubicación:</label>
            <input id="location" v-model="location" type="text" placeholder="Ubicación de la firma" disabled/>
          </div>
          <button class="sign-button" @click="signAndSavePdfs">
            <i class="fas fa-signature"></i> Firmar y Guardar
          </button>
          <br>
          <button class="sign-button" @click="signAndSendPdfs">
            <i class="fas fa-signature"></i> Firmar y Enviar PDFs
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import swal2 from  'sweetalert2'

export default {
  props: {
    p_idAtencion: Number,
    p_idPersona: Number,
    p_numero: Number,
    p_nombreEspecialidad: String,
    p_fechaCita: Date
  },
  data() {
    return {
      pdfUrl: null,
      indicacionesBlob: null,
      certificadoBlob: null,
      keystore: null,
      keystoreName: '',
      password: '',
      reason: 'Entrega de documentos',
      location: 'Quito',
      selectedPdf: 1 // 1 para indicaciones, 2 para certificado
    };
  },
  mounted() {
    this.generatePdf(1); // Generar PDF de indicaciones
    this.generatePdf(2); // Generar PDF de certificado médico
  },
  methods: {
    onKeystoreChange(e) {
      this.keystore = e.target.files[0];
      this.keystoreName = this.keystore ? this.keystore.name : '';
    },
    showPdf(p_idReporte) {
      this.selectedPdf = p_idReporte;
      if (p_idReporte === 1 && this.indicacionesBlob) {
        this.pdfUrl = URL.createObjectURL(this.indicacionesBlob);
      } else if (p_idReporte === 2 && this.certificadoBlob) {
        this.pdfUrl = URL.createObjectURL(this.certificadoBlob);
      }
    },
    async generatePdf(p_idReporte) {
      try {
          const response = await api.get(`/reportes/pdf/${p_idReporte}/${this.p_idAtencion}`, {
              responseType: 'blob'
          });

          const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
          if (p_idReporte === 1) {
              this.indicacionesBlob = pdfBlob;
          } else if (p_idReporte === 2) {
              this.certificadoBlob = pdfBlob;
          }

          // Si es el primero, mostrar el PDF de indicaciones por defecto
          if (p_idReporte === 1) {
              this.pdfUrl = URL.createObjectURL(pdfBlob);
          }
      } catch (error) {
          console.error('Error al generar el PDF:', error);
          
          // SweetAlert2 para mostrar error
          swal2.fire({
              icon: 'error',
              title: 'Error',
              text: 'Error al generar el PDF. Inténtalo de nuevo.',
              showConfirmButton: true
          });
      }
    },

    // Método para firmar y guardar los PDFs
    async signAndSavePdfs() {
      if (!this.keystore || !this.password || !this.indicacionesBlob || !this.certificadoBlob) {
        // SweetAlert2 para advertencia de campos faltantes
        swal2.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Todos los campos son necesarios.',
          showConfirmButton: true
        });
        return;
      }

      try {
        // Firmar los dos PDFs
        const signedIndicaciones = await this.signPdf(this.indicacionesBlob);
        const signedCertificado = await this.signPdf(this.certificadoBlob);

        // Guardar los documentos firmados localmente
        this.saveFile(signedIndicaciones, this.p_numero+'_indicaciones_firmado.pdf');
        this.saveFile(signedCertificado, this.p_numero+'_certificado_firmado.pdf');

        // SweetAlert2 para éxito en la firma y guardado
        swal2.fire({
          icon: 'success',
          title: 'Éxito',
          text: 'Documentos firmados y guardados exitosamente.',
          showConfirmButton: true
        });

      } catch (error) {
        console.log("Error completo:", error);

        // SweetAlert2 para error
        swal2.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al firmar y guardar los documentos.',
          showConfirmButton: true
        });
      }
    },

    // Método para guardar un archivo
    saveFile(blob, fileName) {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    
    async signAndSendPdfs() {
      if (!this.keystore || !this.password || !this.indicacionesBlob || !this.certificadoBlob) {
          // SweetAlert2 para advertencia de campos faltantes
          swal2.fire({
              icon: 'warning',
              title: 'Advertencia',
              text: 'Todos los campos son necesarios.',
              showConfirmButton: true
          });
          return;
      }

      try {
          // Mostrar alerta de progreso antes de comenzar el envío de correo y registro de bitácora
          swal2.fire({
              title: 'Enviando correo y generando registro de bitácora',
              text: 'Por favor espera...',
              allowOutsideClick: false,
              allowEscapeKey: false,
              didOpen: () => {
                  swal2.showLoading(); // Mostrar indicador de carga
              }
          });

          // Firmar los dos PDFs
          const signedIndicaciones = await this.signPdf(this.indicacionesBlob);
          const signedCertificado = await this.signPdf(this.certificadoBlob);

          // Enviar ambos documentos firmados en el mismo correo
          await this.enviarDocumentosPorCorreo(signedIndicaciones, signedCertificado);

          // Registrar la acción en la bitácora
          await this.registrarBitacora();

          // Cerrar la alerta de carga
          swal2.close();

          // SweetAlert2 para éxito en la firma y envío
          swal2.fire({
              icon: 'success',
              title: 'Éxito',
              text: 'Documentos firmados, enviados por correo y registrados en la bitácora exitosamente.',
              showConfirmButton: true
          });

      } catch (error) {
          console.log("Error completo:", error);

          // Cerrar la alerta de carga en caso de error
          swal2.close();

          // SweetAlert2 para error
          swal2.fire({
              icon: 'error',
              title: 'Error',
              text: 'Error al firmar o enviar los documentos.',
              showConfirmButton: true
          });
      }
    },
async signPdf(pdfBlob) {

  let formData = new FormData();
  formData.append('file', pdfBlob, 'documento.pdf');
  formData.append('keystore', this.keystore);

  const response = await api.post('/signature/sign-pdf', formData, {
    params: {
      password: this.password,
      reason: this.reason,
      location: this.location,
      texto: window.sessionStorage.getItem("usuario") || "Texto predeterminado",
      nombreFirmante: "NOMBRE COMPLETO",
      documentoFirmante: "1234567890"
    },
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'blob'
  });

  return new Blob([response.data], { type: 'application/pdf' });
},
    async enviarDocumentosPorCorreo(signedIndicaciones, signedCertificado) {
      let formData = new FormData();
      formData.append('recipient', "chechosmart@gmail.com");
      formData.append('msgBody', "Se envían los documentos PDF firmados:");
      formData.append('subject', "Documentos firmados");

      // Adjuntar los dos documentos firmados
      formData.append('attachments', new File([signedIndicaciones], "indicaciones_firmado.pdf", { type: 'application/pdf' }));
      formData.append('attachments', new File([signedCertificado], "certificado_firmado.pdf", { type: 'application/pdf' }));

      try {
        await api.post('/sendHtmlMailWithAttachment', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        console.log("Correo enviado con éxito");
      } catch (error) {
        console.error('Error al enviar el correo:', error);
      }
    },
    async registrarBitacora() {
      const url = 'http://localhost:8080/api/v1/bitacoras';
      const datos = {
        estado: 1,
        idBitacora: 0,
        idMedioCom: 2, // Puede ser el identificador del medio de comunicación utilizado
        idPersona: this.p_idPersona,
        texto: `Se enviaron los documentos firmados correspondientes a la atención N° ${this.p_numero}, brindada en la especialidad de ${this.p_nombreEspecialidad}, el día ${this.p_fechaCita}.`,
        tipo: 'A' // Asumiendo que 'A' es el tipo de acción
      };

      try {
        const response = await api.post(url, datos, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
        console.log("Registro de bitácora exitoso", response.data);
      } catch (error) {
        console.error("Error al registrar en la bitácora:", error);
      }
    }
  }
};
</script>

<style scoped>
.file-selection {
  margin-bottom: 5px;
}

.container {
  display: flex;
  width: 100%;
  height: 100vh;
}

.row {
  display: flex;
  width: 100%;
}

.col-left {
  flex: 7;
  padding: 20px;
  border-right: 1px solid #ddd;
}

.col-right {
  flex: 3;
  padding: 20px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 2px solid #ccc;
}

.no-pdf {
  text-align: center;
  font-size: 18px;
  color: #888;
  padding: 40px;
}

/* Estilo del contenedor del formulario */
.form-container {
  background: linear-gradient(135deg, #76b5c5 0%, #c0e0f8 100%);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
}

.form-container:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.form-header {
  text-align: center;
  margin-bottom: 20px;
}

.form-header h3 {
  color: #fff;
  font-size: 1.5rem;
}

.form-header p {
  color: #fff;
  font-size: 0.9rem;
}

/* Estilo de los campos de entrada */
.input-group {
  margin-bottom: 15px;
}

.input-group label {
  display: block;
  font-weight: bold;
  color: #fff;
  margin-bottom: 5px;
}

.input-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.input-group input:focus {
  border-color: #76b5c5;
  box-shadow: 0 0 8px rgba(118, 181, 197, 0.5);
}

/* Botón de firmar */
.sign-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  width: 100%;
  transition: background-color 0.3s ease;
}

.sign-button i {
  margin-right: 8px;
}

.sign-button:hover {
  background-color: #45a049;
}

.sign-button:active {
  background-color: #388e3c;
}

/* Ajuste responsivo */
@media (max-width: 768px) {
  .col-right {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>

